import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {SuggestionSelectHandler} from '../../../../../../srcCommon/inboxes/search/searchSuggestionsHelpers';
import {InboxesSearchSuggestionItemProps} from './inboxesSearchSuggestionsDropdownCommons';
import {SearchSuggestionsDropdownItem} from './searchSuggestionsDropdownItem';
import {SearchSuggestionsDropdownSection} from './searchSuggestionsDropdownSection';

/*
 * Props.
 */

interface SearchSuggestionsDropdownRecentQueriesProps {
  recentQueries: ReadonlyArray<InboxesSearchSuggestionItemProps>;
  onSuggestionSelect: SuggestionSelectHandler;
}

/*
 * Component.
 */

export const SearchSuggestionsDropdownRecentQueries: FC<SearchSuggestionsDropdownRecentQueriesProps> = (
  props,
) => {
  const {recentQueries, onSuggestionSelect} = props;

  // If no recent query starts with the current one, do not display them.
  if (recentQueries.length === 0) {
    return null;
  }

  return (
    <SearchSuggestionsDropdownSection
      title={<Trans id="inboxes-search-recent-queries">Recent searches</Trans>}
    >
      {recentQueries.map((recentQuery) => (
        <SearchSuggestionsDropdownItem
          key={recentQuery.value}
          onSelect={(e, key) => onSuggestionSelect(recentQuery.value, key, recentQuery.onSelectOptions)}
          activeToken={{value: undefined}}
          value={recentQuery.value}
          fuzzyQuery={recentQuery.fuzzyQuery}
        />
      ))}
    </SearchSuggestionsDropdownSection>
  );
};
